import { FormItemType } from '../types/types';

// Default value for a form field by its type. Used when building the submit
// request body and when a handler returns null to reset a field to the same
// value it would carry on submit.
export const getDefaultValueByType = (
  type?: FormItemType
): boolean | string | null => {
  switch (type) {
    case 'boolean':
      return false;
    case 'string':
      return '';
    default:
      return null;
  }
};
